module.exports = __webpack_public_path__ + "static/media/03.9a777725.mp3";